import { apiServer, pubApiServer } from "../config";
import { Storage } from "../storage";
import { SavedPlaceList } from "../types";
import { fetchWithToken } from "./fetchWithToken";

export async function getAllSavedPlaces(accessToken: string) {
  const response = await fetchWithToken(
    `${pubApiServer}/savedplaces/list-all-savedplace`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
  if (response === null) {
    return null;
  }
  const data = (await response.json()) as {
    status: string;
    message: string;
    data: {
      saved_places: SavedPlaceList[];
      total_all_saved_places: {
        totalPlaces: number;
      }[];
    };
  };
  if (data.status === "error") {
    throw new Error(data.message);
  }
  return data.data;
}

export async function createList(
  accessToken: string,
  listName: string,
  venueId: number
) {
  const formData = new FormData();
  formData.append("name", listName);
  formData.append("business_id", venueId.toString());
  console.log("formData", formData);
  const response = await fetchWithToken(
    `${apiServer}/savedplaces/store-savedplace-with-business`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      body: formData,
    }
  );
  if (!response) {
    return null;
  }
  const data = (await response.json()) as {
    status: string;
    message: string;
    data: {
      saved_places: SavedPlaceList[];
      total_all_saved_places: {
        totalPlaces: number;
      }[];
    };
  };
  if (data.status === "error") {
    throw new Error(data.message);
  }
  return data.data;
}

export async function createListEmpty(accessToken: string, listName: string) {
  const formData = new FormData();
  formData.append("name", listName);
  const response = await fetchWithToken(
    `${apiServer}/savedplaces/store-savedplace`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      body: formData,
    }
  );
  if (!response) {
    return null;
  }
  const data = (await response.json()) as {
    status: string;
    message: string;
    data: {
      saved_places: SavedPlaceList[];
      total_all_saved_places: {
        totalPlaces: number;
      }[];
    };
  };
  if (data.status === "error") {
    throw new Error(data.message);
  }
  return data.data;
}

export async function saveVenueToLists(
  lists: number[],
  accessToken: string,
  venueId: number
) {
  const formData = new FormData();
  formData.append("business_id", venueId.toString());
  formData.append("savedPlacesIds", JSON.stringify(lists));
  const response = await fetchWithToken(
    `${apiServer}/savedplaces/add-business-to-saved-places`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      body: formData,
    }
  );
  if (!response) {
    return null;
  }
  const data = (await response.json()) as {
    status: string;
    message: string;
    data: {
      saved_places: SavedPlaceList[];
      total_all_saved_places: {
        totalPlaces: number;
      }[];
    };
  };
  if (data.status === "error") {
    throw new Error(data.message);
  }

  const dataResponse = { data, message: data.message };
  // return data.data;
  return dataResponse;
}

export async function deleteSavedPlace(
  savedPlaceListType: string,
  savedPlaceListId: string,
  savedPlaceDetailId: string,
  accessToken: string
) {
  const formData = new FormData();
  formData.append("savedPlaceDetailId", savedPlaceListType);
  formData.append("saved_place_id", savedPlaceListId);
  formData.append("saved_place_detail_id", savedPlaceDetailId);

  const response = await fetchWithToken(
    `${apiServer}/savedplaces/delete-savedplace-detail`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      body: formData,
    }
  );
  if (!response) {
    return null;
  }
  const data = (await response.json()) as {
    status: string;
    message: string;
    data: {
      saved_places: SavedPlaceList[];
      total_all_saved_places: {
        totalPlaces: number;
      }[];
    };
  };
  if (data.status === "error") {
    throw new Error(data.message);
  }
  return data.data;
}

export async function deleteSavedPlaceList(
  savedPlaceId: string,
  accessToken: string
) {
  //AnalyticsService.trackGAEventHandler("mySavedPlacesErrorRemovingSavedPlace");
  //AnalyticsService.trackMx("mySavedPlacesErrorRemovingSavedPlace", {});

  const formData = new FormData();
  formData.append("saved_place_id", savedPlaceId);

  const response = await fetchWithToken(
    `${apiServer}/savedplaces/delete-savedplace`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      body: formData,
    }
  );
  if (!response) {
    return null;
  }
  const data = (await response.json()) as {
    status: string;
    message: string;
    data: {
      saved_places: SavedPlaceList[];
      total_all_saved_places: {
        totalPlaces: number;
      }[];
    };
  };
  if (data.status === "error") {
    throw new Error(data.message);
  }
  return data.data;
}

export async function updateSavedListCoverPhoto(
  savedPlaceId: string,
  coverPhoto: string,
  accessToken: string
) {
  const formData = new FormData();
  formData.append("saved_place_id", savedPlaceId);
  const file = {
    uri: coverPhoto,
    type: "image/jpeg",
    name: "image",
  };
  formData.append(`cover_photo`, file as any, "cover_photo");

  const response = await fetchWithToken(
    `${apiServer}/savedplaces/update-cover-photo`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      body: formData,
    }
  );
  if (!response) {
    return null;
  }
  const data = (await response.json()) as {
    status: string;
    message: string;
    data: {
      saved_places: SavedPlaceList[];
      total_all_saved_places: {
        totalPlaces: number;
      }[];
    };
  };
  if (data.status === "error") {
    throw new Error(data.message);
  }
  return data.data;
}

export async function renameList(
  savedPlaceId: string,
  accessToken: string,
  newName: string
) {
  const formData = new FormData();
  formData.append("saved_place_id", savedPlaceId);
  formData.append("name", newName);

  const response = await fetchWithToken(
    `${apiServer}/savedplaces/rename-savedplace`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      body: formData,
    }
  );
  if (!response) {
    return null;
  }
  const data = (await response.json()) as {
    status: string;
    message: string;
    data: {
      saved_places: SavedPlaceList[];
      total_all_saved_places: {
        totalPlaces: number;
      }[];
    };
  };
  if (data.status === "error") {
    throw new Error(data.message);
  }
  return data.data;
}

export async function fetchSavedList(
  listId: string,
  profileId?: string,
  accessToken?: string
) {
  const formData = new FormData();
  formData.append("saved_place_id", listId);
  if (profileId) {
    formData.append("view_profile_id", profileId);
  }
  formData.append("sort_by", "latest");
  const response = await fetchWithToken(
    `${pubApiServer}/savedplaces/list-savedplace`,
    {
      method: "POST",
      headers: accessToken
        ? {
            Authorization: `Bearer ${accessToken}`,
          }
        : undefined,
      body: formData,
    }
  );
  if (!response) {
    return null;
  }
  const data = (await response.json()) as {
    status: string;
    message: string;
    data: {
      saved_places: SavedPlaceList[];
      total_all_saved_places: {
        totalPlaces: number;
      }[];
    };
  };
  if (data.status === "error") {
    throw new Error(data.message);
  }
  return data.data;
}

export async function updateSavedListCoverPhotoDesktop(
  savedPlaceId: string,
  coverPhoto: File,
  accessToken: string
) {
  const formData = new FormData();
  formData.append("saved_place_id", savedPlaceId);
  // const file = {
  //   uri: coverPhoto,
  //   type: "image/jpeg",
  //   name: "image",
  // };
  // formData.append(`cover_photo`, file as any, "cover_photo");

  formData.append("cover_photo", coverPhoto, coverPhoto.name); // Use the file directly

  const response = await fetchWithToken(
    `${apiServer}/savedplaces/update-cover-photo`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      body: formData,
    }
  );
  if (!response) {
    return null;
  }
  const data = (await response.json()) as {
    status: string;
    message: string;
    data: {
      saved_places: SavedPlaceList[];
      total_all_saved_places: {
        totalPlaces: number;
      }[];
    };
  };
  if (data.status === "error") {
    throw new Error(data.message);
  }
  return data.data;
}
